import ShortRentalPage from './short-rental-page';
export default ShortRentalPage;